export default __webpack_public_path__ + "static/media/img_resume_sample.0947b43a.png";